import { configureStore } from '@reduxjs/toolkit'

import filtersReducer from './slices/filterSlice'
import genericModalReducer from './slices/modalSlice'

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    genericModal: genericModalReducer
  }
})
